import { useCallback, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { getAllCommunityPrices } from "../../../services/pricemanagment";
import { LocationTariff, CommunityPriceRow } from "../types";
import { mapToCommunityPriceRows } from "../utils/tariff";

export type ToastLevel = "success" | "error" | "warn" | "info";

export const useCommunityPrices = () => {

  const toastRef = useRef<Toast>(null);
  const [rows, setRows] = useState<CommunityPriceRow[]>([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [search, setSearch] = useState("");

  const showToast = (
    severity: ToastLevel,
    summary: string,
    detail: string,
    life = 4000
  ) => {
    toastRef.current?.show({ severity, summary, detail, life });
  };

  const fetchPrices = useCallback(async () => {
    const firstLoad = initialLoading;
    if (!firstLoad) setRefreshing(true);
    try {
      const data: LocationTariff[] = await getAllCommunityPrices();
      setRows(mapToCommunityPriceRows(data));
    } catch (e: any) {
      const msg = e?.response?.data?.error ?? "Failed to load community prices.";
      showToast("error", "Error", msg);
    } finally {
      if (firstLoad) setInitialLoading(false);
      else setRefreshing(false);
    }
  }, [initialLoading]);

  useEffect(() => {
    fetchPrices();
  }, [fetchPrices]);

  return { rows, initialLoading, refreshing, search, setSearch, toastRef, refetch: fetchPrices };
  
};
